<template>
    <div>
        <dx-grid
            :url="url"
            name="call-logs"
            :columns="columns"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            :actions="actions"
            ref="grid"
            :expandedOptions="{
                enabled: true,
                allowExpandingAll: true,
                template: 'call-details',
            }"
        ></dx-grid>

        <v-dialog persistent v-model="broadcastCallDialog" max-width="1200">
            <broadcast-call
                :closeDialog="closeBroadcastDialog"
                :openSnakbar="openSnakbar"
            ></broadcast-call>
        </v-dialog>
        <v-snackbar
            color="info"
            top
            right
            :timeout="snackbarTimeout"
            v-model="processingCallsSnackbar"
            dark
        >
            <v-layout column>
                <div class="headline mb-2">
                    {{ processingCalls }}
                </div>
            </v-layout>
            <v-icon size="16" @click="processingCallsSnackbar = false">
                mdi-close-circle
            </v-icon>
        </v-snackbar>
    </div></template
>
<script>
import moment from "moment";
import { formatPhoneNumber, toISOLocal } from "../../utils/helpers.js";
import broadcastCall from "./BroadcastCall.vue";

export default {
    components: {
        broadcastCall,
    },
    data: () => ({
        title: "Calls",

        broadcastCallDialog: false,
        actions: [],
        url: "",
        user: "",
        processing: false,
        action: "",

        snackbarTimeout: 0,
        processingCallsSnackbar: false,
        processingCalls: "",
        requestID: "",

        columns: [
            {
                field: "direction",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value) => {
                    switch (value) {
                        case "INC":
                            return "mdi-phone-incoming";
                        case "OUT":
                            return "mdi-phone-outgoing";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    switch (value) {
                        case "INC":
                            return "info";
                        case "OUT":
                            return "#2196f3";
                        default:
                            return "";
                    }
                },
            },
            {
                label: "Account ID",
                field: "accountID",
                template: "link-action-cell-template",
                format: "",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Hebrew Name",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(moment()),
                selectedFilterOperation: "=",
            },
            {
                label: "From",
                field: "from",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "To",
                field: "to",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Type",
                field: "type",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     label: "Recording",
            //     template: "link-audio-cell-template",
            //     field: "recording",
            //     visible: true,
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            {
                label: "Direction",
                field: "direction",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "User",
                field: "userName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "End Time",
                field: "callEndTime",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Internal Number",
                field: "internalNumber",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Call Name",
                field: "broadcastName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {
        this.columns.find(
            (c) => c.field == "accountID",
        ).linkAction = this.onAccountIDClick;

        this.user = this.$store.state.authentication.user;

        // this.actions.push({
        //     text: "Broadcat Call",
        //     action: this.broadcatCall,
        //     showOnSelection: false,
        // });

        this.subscribeToPusher();
    },
    mounted() {},
    beforeDestroy() {
        this.pusher.unsubscribe("broadcast");
    },
    methods: {
        async beforeSetupGrid() {
            this.columns.find(
                (c) => c.field == "accountID",
            ).linkAction = this.onAccountIDClick;

            this.url = "calls?type=&callName=&broadcastID=";
        },
        subscribeToPusher() {
            this.pusher = new Pusher("33b9d9d711ad50d8a7ef", {
                cluster: "mt1",
            });

            var channel = this.pusher.subscribe("broadcast");

            this.pusher.connection.bind("error", function(err) {
                console.log(err);
            });

            channel.bind("broadcast-call", (call) => {
                this.updateProcessingCalls(call);
            });
        },
        updateProcessingCalls(call) {
            if (call.requestID != this.requestID) return;

            if (call.index == call.total) {
                this.processingCalls = "";
                this.processingCallsSnackbar = false;
            } else {
                this.processingCalls =
                    call.index + "/" + call.total + " " + call.text;
            }
        },
        broadcatCall() {
            this.broadcastCallDialog = true;
            // this.$router.push({
            //     path: "/call/broadcast-call",
            // });
        },
        onAccountIDClick(row) {
            this.onRowClicked(row);
        },
        async onRowClicked(row) {
            if (row.accountID) {
                this.$router.push({
                    name:
                        row.accountsSource == "DINNER"
                            ? "DinnerAccountView"
                            : "Account View",
                    params: {
                        id: row.accountID,
                    },
                });

                return;
            }
        },
        formatPhoneNumber(value) {
            return formatPhoneNumber(value.substring(1));
        },
        closeBroadcastDialog() {
            this.broadcastCallDialog = false;
        },
        openSnakbar(requestID) {
            this.requestID = requestID;

            this.processingCallsSnackbar = true;
        },
    },
};
</script>
